import React from "react";
import { useNavigate } from "react-router-dom";
import HeroImg from "../assets/heroImg.png";
import Branding from "../assets/BrandingBanner.png";
import IMgage from "../assets/image424.png";
import IMage1 from "../assets/image433.png";

import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { GoArrowUpRight } from "react-icons/go";

const Slider = () => {
  const navigate = useNavigate();

  const serviceList = [
    {
      index: 1,
      title: "MARKETING",
      para: "Marketing exists to boost sales and we are here: your one-stop solution to growth and scalability.",
      img: HeroImg,
      link: "/marketing",
    },
    {
      index: 2,
      title: "iOS/Android App",
      para: "We build a Application and User-friendly for all device.",
      img: Branding,
      link: "/android",
    },
    {
      index: 3,
      title: "WEB DEVELOPMENT",
      para: "Building scalable websites to empower your business and achieve milestones.",
      img: IMage1,
      link: "/webdevelopment",
    },
    {
      index: 4,
      title: "UI/UX DESIGN",
      para: "Empowering professionals to compete and unlock new opportunities. Let’s talk digital!",
      img: IMgage,
      link: "/uxui",
    },
  ];

  return (
    <section id="heroSection" className="w-full overflow-hidden">
      <Swiper
        autoplay={{
          delay: 3000,
          disableOnInteraction: false,
        }}
        loop={true}
        modules={[Autoplay, Pagination]}
        slidesPerView={1}
        spaceBetween={30}
        breakpoints={{
          640: { slidesPerView: 1 },
          768: { slidesPerView: 1 },
          1024: { slidesPerView: 1 },
        }}
        className="w-full"
      >
        {serviceList.map((item) => (
          <SwiperSlide key={item.index}>
            <div
              className="flex items-center justify-center h-[300px] md:h-[700px] bg-cover bg-center"
              style={{ backgroundImage: `url(${item.img})` }}
            >
              <div className="bg-black bg-opacity-50 w-full h-full flex flex-col justify-center items-center">
                <h2 className="text-yellow-600 font-semibold text-2xl md:text-5xl px-4 text-center">
                  {item.title}
                </h2>
                <p className="text-white text-sm md:text-lg mt-4 px-4 md:px-16 text-center">
                  {item.para}
                </p>
                <button
                  onClick={() => navigate(item.link)}
                  className="mt-6 flex items-center gap-8 px-6 py-1.5 border border-transparent bg-orange-500 text-white font-semibold rounded-sm hover:bg-orange-600 hover:border-white transition duration-300 transform hover:scale-105 active:scale-95"
                >
                  <span className="text-lg transition-transform duration-300 group-hover:translate-x-1">
                    <GoArrowUpRight />
                  </span>
                  Read More
                </button>
              </div>
            </div>
          </SwiperSlide>
        ))}
      </Swiper>
    </section>
  );
};

export default Slider;
